import { useEffect, useState } from "react";
import styled from "styled-components";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import YachtClubRegistrationHeader from "../../components/YachtClub/YachtClubRegistration/YachtClubRegistrationHeader";
import YachtClubRegistrationTable from "../../components/YachtClub/YachtClubRegistration/YachtClubRegistrationTable";
import YachtRegistrationHistory from "../../components/YachtClub/YachtRegistrationHistory/YachtRegistrationHistory";
import {
  getFormattedYachtHistoryData,
  getFormattedYachtRegistrationData,
} from "../../helper";
import {
  getYachtRegistrationHistory,
  getYachtRegistrationList,
} from "../../services/yachtClubService";

const YachtClub = () => {
  const [registrationData, setRegistrationData] = useState([]);
  const [isRegTableLoading, setRegTableLoading] = useState(false);

  const [registrationHistory, setRegistrationHistory] = useState([]);
  const [isHistoryTableLoading, setHistoryTableLoading] = useState(false);

  const [isFailureModal, setIsFailureModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });

  const [totalHistoryData, setTotalHistoryData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 5;

  useEffect(() => {
    fetchYachtRegistrationList();
    fetchYachtHistoryList(currentPage, limit);
  }, []); // eslint-disable-line

  const fetchYachtRegistrationList = async () => {
    setRegTableLoading(true);
    try {
      const response = await getYachtRegistrationList();
      if (response.data.code === 200) {
        setRegTableLoading(false);
        setRegistrationData(
          getFormattedYachtRegistrationData(response.data.data)
        );
      }
    } catch (error: any) {
      setRegTableLoading(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const fetchYachtHistoryList = async (currentPage: number, limit: number) => {
    setHistoryTableLoading(true);
    try {
      const response = await getYachtRegistrationHistory(currentPage, limit);
      if (response.data.code === 200) {
        setHistoryTableLoading(false);
        setTotalHistoryData(response.data.count);
        setRegistrationHistory(
          getFormattedYachtHistoryData(response.data.data)
        );
      }
    } catch (error: any) {
      setHistoryTableLoading(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchYachtHistoryList(page, limit);
  };

  return (
    <YachtClubContainer>
      <YachtClubRegistrationHeader />
      <YachtClubRegistrationTable
        data={registrationData}
        isTableDataLoading={isRegTableLoading}
      />
      <YachtRegistrationHistory
        data={registrationHistory}
        isTableDataLoading={isHistoryTableLoading}
        totalData={totalHistoryData}
        currentPage={currentPage}
        rowsPerPage={limit}
        onPageChange={(page: number) => handlePageChange(page)}
      />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
    </YachtClubContainer>
  );
};

const YachtClubContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default YachtClub;
